<template>
  <div class="flex items-center bg-secondary-subtle rounded px-2.5 py-1 border border-primary">
    <slot />
  </div>
</template>

<script setup>

</script>
